export default {
  // Text Panel
  '文本': 'Texto',
  '颜色': 'Color',
  '字体': 'Fuente',
  '大写': 'Mayúsculas',
  '字号': 'Tamaño de fuente',
  '背景色': 'Color de fondo',
  '圆角': 'Radio de borde',
  '内边距': 'Relleno',
  '描边': 'Trazo',
  '对齐': 'Alineación',
  '底边距': 'Margen inferior',
  '紧贴底边': 'Alinear inferior',
  '垂直居中': 'Centro vertical',

  // Basic Panel
  '基础': 'Básico',
  '位置': 'Posición',
  '尺寸': 'Tamaño',
  '旋转': 'Rotación',
  '居中': 'Centrar',
  '原始尺寸': 'Tamaño original',
  '平铺': 'Mosaico',
  '拉伸': 'Estirar',
  '透明度': 'Opacidad',
  '视频尺寸为{width}x{height}。': 'El tamaño del video es {width}x{height}.',
  '调整文本尺寸可能会改变文本展示效果，建议调整字体大小': 'Ajustar el tamaño del texto puede cambiar el efecto de visualización, se recomienda ajustar el tamaño de la fuente',

  // Library
  '视频': 'Video',
  '音频': 'Audio',
  '图片': 'Imagen',
  '新建文本': 'Nuevo texto',
  '花字库': 'Biblioteca de fuentes',
  '默认文本': 'Texto predeterminado',

  // Export
  '导出': 'Exportar',

  // Tools
  '撤销': 'Deshacer',
  '重做': 'Rehacer',

  // Tooltips
  '清除选中': 'Limpiar selección',
  '删除当前选中': 'Eliminar selección',
  '分割当前选中': 'Dividir selección',
  '分割当前选中，只保留左侧': 'Dividir selección, mantener solo la izquierda',
  '分割当前选中，只保留右侧': 'Dividir selección, mantener solo la derecha',
  '水平翻转': 'Voltear horizontalmente',
  '将连续且相邻的素材拼接后下载': 'Concatenar y descargar materiales adyacentes',

  // Library
  '当前': 'Actual',
  '导入': 'Importar',
  '全部': 'Todos',
  '删除': 'Eliminar',
  '拖拽视频到这里': 'Arrastre el video aquí',
  '拖拽音频到这里': 'Arrastre el audio aquí',
  '拖拽图片到这里': 'Arrastre la imagen aquí',
  '或者点击上传': 'o haga clic para cargar',
  '暂无素材，请先导入素材': 'No hay materiales, por favor importe materiales primero',

  // Manager
  '选择一个视频，开始你的创作。': 'Seleccione un video y comience su creación.',

  // Animation Panel
  '动画': 'Animación',
  '入场动画': 'Animación de entrada',
  '出场动画': 'Animación de salida',
  '关键帧动画': 'Animación de keyframe',
  '选择动画效果': 'Seleccione un efecto de animación',
  '添加': 'Agregar',
  '确定删除此动画？': '¿Estás seguro de borrar esta animación?',
  '持续时间': 'Duración',
  '秒': 'seg',
  '起始时间': 'Hora de inicio',
  '结束时间': 'Hora de fin',
  '暂无动画，请添加动画效果': 'No hay animaciones, por favor agrega efectos de animación',

  // Animation Presets
  '淡入': 'Entrada suave',
  '从左滑入': 'Deslizar desde la izquierda',
  '从右滑入': 'Deslizar desde la derecha',
  '从上滑入': 'Deslizar desde arriba',
  '从下滑入': 'Deslizar desde abajo',
  '放大进入': 'Ampliar',
  '旋转进入': 'Rotación entrada',
  '淡出': 'Salida suave',
  '向左滑出': 'Deslizar hacia la izquierda',
  '向右滑出': 'Deslizar hacia la derecha',
  '向上滑出': 'Deslizar hacia arriba',
  '向下滑出': 'Deslizar hacia abajo',
  '缩小退出': 'Reducir',
  '旋转退出': 'Rotación salida',
  '脉冲': 'Pulso',
  '抖动': 'Sacudir',
  '弹跳': 'Rebote',
  '摆动': 'Cabeceo',
  '闪烁': 'Destello',
  '自定义': 'Personalizado',
  '起始状态': 'Estado inicial',
  '结束状态': 'Estado final',
  '位置 X': 'Posición X',
  '位置 Y': 'Posición Y',
  '缩放': 'Escala',
  '旋转角度': 'Rotación',
  '不透明度': 'Opacidad',

  // Filter Panel
  '可用滤镜': 'Filtros disponibles',
  '滤镜参数': 'Parámetros de filtro',
  '选择滤镜': 'Seleccionar filtro',
  '请选择要编辑的滤镜': 'Por favor, seleccione un filtro para editar',
  '强度': 'Intensidad',
  '请选择一个滤镜以调节参数': 'Por favor, seleccione un filtro para ajustar los parámetros',
  '灰度': 'Escala de grises',
  '模糊': 'Desenfoque',
  '亮度': 'Brillo',
  '对比度': 'Contraste',
  '饱和度': 'Saturación',

  '无': 'Ninguno',
  '入场': 'Entrada',
  '出场': 'Salida',
  '动效': 'Animación',
  '结束位置': 'Posición final',
  '使用当前时间轴上的当前时间点': 'Usar el punto de tiempo actual en la línea de tiempo',
  '开始位置': 'Posición inicial',
  '当前有动画，调整可能不能直接看到效果，请播放片段查看': 'La animación actual puede no mostrar un efecto directo, por favor reproduce el segmento para verificar',
  '滤镜': 'Filtro',
  '恢复正在编辑的数据': 'Restaurar datos en edición',
  '转场': 'Transición',
  '转场效果': 'Efectos de transición',
  '点击应用': 'Haga clic para aplicar',
  '仅支持视频和图片': 'Solo admite videos e imágenes',
  '删除转场': 'Eliminar transición',
  '已经存在视频转场，请先删除': 'Ya existe una transición de video, por favor elimínela primero',
  '当前片段是轨道最后一个片段，不能应用转场效果': 'El segmento actual es el último de la pista, no se puede aplicar un efecto de transición',
  '暂无转场效果': 'No hay efectos de transición disponibles',
  '片段不存在': 'El segmento no existe',
  '请先选择一个片段': 'Por favor, seleccione un segmento primero',
  '轨道不存在': 'La pista no existe',
  '默认': 'Predeterminado',

  // 转场效果
  '淡入淡出': 'Fundido',
  '滑动': 'Deslizamiento',
  '百叶窗': 'Persianas',
  '溶解': 'Disolución',

  // Video/Audio Panel
  '音量': 'Volumen',
  '请先选择视频片段': 'Por favor, seleccione primero un segmento de video',
  '请先选择音频片段': 'Por favor, seleccione primero un segmento de audio',
  '重置': 'Restablecer',

  // Advanced Export
  '高级导出': 'Exportación avanzada',
  '取消': 'Cancelar',
  '正在导出...': 'Exportando...',
  '导出完成！': 'Exportación completada!',
  '导出失败：': 'Exportación fallida: ',
  '导出类型': 'Tipo de exportación',
  '输出格式': 'Formato de salida',
  '分辨率': 'Resolución',
  '帧率': 'FPS',
  '视频比特率': 'Bitrate de video',
  '编码格式': 'Codec',
  '包含音频': 'Incluir audio',
  '关闭时将导出无声音的视频': 'Exporta video sin sonido cuando está desactivado',
  '音频比特率': 'Bitrate de audio',
  '比特率': 'Bitrate',
  '采样率': 'Tasa de muestreo',
  '导出中...': 'Exportando...',
  '开始导出': 'Iniciar exportación',
};